/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // function LogosSlider() {
  //   this.slideshow = document.querySelector('[data-logos-slider]')
  //   const speedElement = this.slideshow.getAttribute('data-slider-speed');
  //   this.speed = speedElement ? parseInt(speedElement) : false;

  //   if (!this.slideshow) return;

  //   this.flickity = null;

  //   this.init()
  // }

  // LogosSlider.prototype.init = function() {
  //   this.flickity = new themeVendor.Flickity(this.slideshow, {
  //     initialIndex: 0,
  //     autoPlay: this.speed,
  //     contain: true,
  //     pageDots: false,
  //     adaptiveHeight: true,
  //     wrapAround: true,
  //     groupCells: false,
  //     cellAlign: 'left',
  //     freeScroll: true,
  //     prevNextButtons: false,
  //     draggable: true,
  //     rightToLeft: window.isRTL,
  //     on: {
  //       ready: () => {
  //         setTimeout(() => {
  //           this.slideshow.dispatchEvent(
  //             new CustomEvent('theme:logos:loaded', {
  //               bubbles: true,
  //               detail: {
  //                 slider: this,
  //               },
  //             })
  //           );
  //         }, 50);
  //       },
  //     },
  //   })

  //   document.addEventListener('theme:resize', () => {
  //     this.flickity.resize();
  //   });
  // }

  // window.addEventListener('DOMContentLoaded', (e) => {
  //   const slider = new LogosSlider();
  // })


  // swiper logo slider
  const slider = new Swiper('.logo-content', {
    allowTouchMove: false,
    loop: true,
    slidesPerView: 'auto',
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });

  //customer review
  var swiper = new Swiper(".customer-review-lists", {
    slidesPerView: 3,
    spaceBetween: 28,
    slidesPerGroup: 3,
    loop: true,
    loopFillGroupWithBlank: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // TOPへスクロール
  document.querySelector('.js-scrolltop').addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({
      top: 0,
      behavior: 'smooth'
    })
  });

  window.addEventListener('scroll', () => {
    if (document.querySelector('.homepage-slideshow')) {
      let fv_height = document.querySelector('.homepage-slideshow').getBoundingClientRect().height;
      let scroll = window.pageYOffset;
      let to_top_btn = document.querySelector('.js-scrolltop');

      if(scroll > fv_height) {
        to_top_btn.classList.add('is-active');
      } else {
        to_top_btn.classList.remove('is-active');
      }
    }
  })

})();
